<script setup lang="ts"></script>

<template>
  <NuxtLink to="/workplace-of-the-future" class="ticker-wrapper" aria-label="Learn more about Workplace of the Future">
    <div class="ticker-track">
      <div class="marquee">
        Zenapptic is hosting the <b>Workplace of the Future</b>, October 14th, in New York at Tad.
        <b>Click here</b>
        to register and help shape the future of work!
      </div>
      <div class="marquee" aria-hidden="true">
        Zenapptic is hosting the <b>Workplace of the Future</b>, October 14th, in New York at Tad.
        <b>Click here</b>
        to register and help shape the future of work!
      </div>
    </div>
  </NuxtLink>
</template>

<style lang="scss">
.ticker-wrapper {
  align-items: center;
  background-color: black;
  display: flex;
  flex-flow: row nowrap;
  gap: 2rem;
  overflow: hidden;
  padding: 2.4rem 0;
  text-decoration: none;

  &:hover .ticker-track {
    animation-play-state: paused;
  }

  .load-message,
  .marquee {
    color: white;
    font-size: 2.7rem;
    // font-style: italic;
    font-weight: 100;
    line-height: 1;
    text-transform: uppercase;

    p {
      font-size: 2.7rem;
    }

    b {
      font-weight: 700;
    }
  }

  .load-message {
    text-align: center;
    width: 100%;
  }

  .ticker-track {
    animation: marquee 20s linear infinite;
    display: flex;
    flex: 0 0 auto;
    width: max-content;

    @media only screen and (max-width: 767px) {
      animation-duration: 40s;
    }

    .marquee {
      flex: 0 0 auto;
      padding-right: 6rem;
      white-space: nowrap;
    }
  }

  @keyframes marquee {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }
}
</style>
